<template>
  <div class="authors mk-container">
    <div class="pgnnp-header">
      <Paganiniplus />
    </div>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <Transition name="fade" mode="out-in">
      <div v-if="isLoaded" key="isLoaded" class="container--list">
        <div class="top-side">
          <h1 class="authors-title">
            {{ $t('AUTHOR.LIST') }}
          </h1>
        </div>
        <div class="center">
          <div class="left-side">
            <div class="authors-list">
              <div v-if="authorList.length > 0">
                <ArticleAuthorList :authors="authorList" />
                <div class="more">
                  <Loader :loading="loading" />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="right-side">
            <Paganiniplus />
            <Paganiniplus />
            <Paganiniplus />
          </div> -->
        </div>
        <div class="bottom-side">
          <div v-if="!loading && !isLastPage && loadMoreCounter > 2">
            <LoadMoreBtn :btn-content="$t('ARTICLE.MORE')" :on-click="manualLoadMore" />
          </div>
        </div>
      </div>
      <div v-else key="isNotLoaded" class="container--loader">
        <Loader :loading="isLoaded" />
      </div>
    </Transition>
  </div>
</template>

<script>
import AuthorService from '@/assets/services/AuthorService'

import Loader from '@/components/common/Loader'
import Paganiniplus from '@/components/tsp/Paganiniplus'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import LoadMoreBtn from '@/components/common/LoadMoreBtn'
import ArticleAuthorList from '@/components/article/ArticleAuthorList'

export default {
  name: 'Authors',
  components: {
    Loader,
    Breadcrumbs,
    Paganiniplus,
    ArticleAuthorList,
    LoadMoreBtn
  },
  directives: {},
  props: {},
  data() {
    return {
      breadcrumbs: this.$route.meta.breadcrumbs,
      page: {
        perPage: 10, // default
        current: 1,
        last: 0,
        total: 0
      },
      // ---------------------
      authorList: undefined,
      loading: true,
      loadMoreDebounceTimer: 0,
      loadMoreCounter: 1
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    isLoaded() {
      return this.authorList
    },
    locale() {
      return this.$i18n.locale
    },
    isLastPage() {
      return this.page.last <= this.page.current
    },
    title() {
      return `${this.$t('AUTHOR.LIST')} | ${this.$t('READ.TITLE')} | MUZIK AIR`
    },
    description() {
      return this.$t('AUTHOR.LIST')
    },
    keywords() {
      if (this.authorList) {
        return this.$t('AUTHOR.LIST') + ', ' + this.authorList.map(author => author.name).join(', ')
      } else {
        return this.$t('AUTHOR.LIST')
      }
    },
    cover() {
      return `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/read.png`
    },
    canonicalURL() {
      return `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/authors`
    },
    structuredData() {
      const structuredData = {
        '@context': 'http://schema.org',
        '@type': 'ItemList',
        '@id': this.canonicalURL,
        'itemListElement': []
      }
      if (this.authorList) {
        this.authorList.forEach((author, index) => {
          structuredData.itemListElement.push({
            'position': index,
            '@type': 'ListItem',
            '@id': `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/authors/${author.id}`,
            'url': `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/authors/${author.id}`,
            'image': author.avatar,
            'name': author.name,
            'description': author.description
          })
        })
      }
      return structuredData
    }
  },
  watch: {
    // locale() {}
  },
  created() {
    this.getAuthorList(this.page.current)
  },
  mounted() {
    // console.log('mounted this.$route', this.$route)
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  updated() {},
  methods: {
    async getAuthorList(page) {
      this.loading = true
      const params = {
        'per_page': this.page.perPage,
        'page': page || this.page.current
      }
      const authorsData = await AuthorService.getAuthors(params)
      if (authorsData) {
        this.authorList = this.authorList
          ? this.authorList.concat(authorsData.data)
          : authorsData.data
        this.page.total = authorsData['total'] || 0
        this.page.last = authorsData['last_page'] || 0
      } else {
        this.authorList = []
      }
      this.loading = false
    },
    debouncedLoadMore() {
      if (!this.isLastPage && !this.loading) {
        this.loading = true
        if (this.loadMoreDebounceTimer) {
          clearTimeout(this.loadMoreDebounceTimer)
          // this.loadMoreDebounceTimer = 0
        }
        this.loadMoreDebounceTimer = setTimeout(() => {
          this.loadMore()
          this.loadMoreDebounceTimer = 0
        }, 300)
      }
    },
    async loadMore() {
      if (this.page.current < this.page.last) {
        await this.getAuthorList(this.page.current + 1)
        this.loadMoreCounter = (this.loadMoreCounter + 1)
        this.page.current++
        this.loading = false
      }
      // else no more page
    },
    manualLoadMore() {
      this.loadMoreCounter = 0
      this.debouncedLoadMore()
    },
    onScroll() {
      const scrollTop = window.pageYOffset // document.body.scrollTop;
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight
      const scrollPercentage = scrollTop / (documentHeight - windowHeight)
      if (scrollPercentage > 0.90 && this.loadMoreCounter < 3) {
        // console.log('scrollPercentage', scrollPercentage, scrollTop, windowHeight, documentHeight)
        this.debouncedLoadMore()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.authors {
  .container--loader {
    display: block;
    min-height: 200px;
    margin: 24px auto;
    text-align: center;
  }
  .container--list {
    min-height: 200px;
    margin: 24px 0;
    font-size: 16px;
    color: #7b7b7b;
    overflow: hidden;
    .more {
      text-align: center;
    }
  }
  .top-side {
    display: block;
    margin-bottom: 24px;
  }
  .center {
    position: relative;
    overflow: hidden;
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .left-side {
    position: relative;
    overflow: hidden;
    // margin-right: 24px;
    // float: left;
    // width: calc(100% - 322px - 24px);
    width: 100%;
  }
  .right-side {
    position: relative;
    overflow: hidden;
    width: 322px;
    > div {
      margin-bottom: 24px;
    }
  }
  &-title {
    display: block;
    margin: 0;
    line-height: 54px;
    font-size: 36px;
    font-weight: 500;
    line-height: 54px;
    color: $grey-50;
  }
  &-name {
    color: $theme-red;
  }
}

.pgnnp-header {
  margin-top: 24px;
}

@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .authors {
    .container--list {
      margin: 24px 0;
    }
    .left-side {
      display: block;
      width: 100%;
    }
    .right-side {
      display: none;
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .authors {
    .container--list {
      margin: 24px 0;
    }
    .left-side {
      display: block;
      width: 100%;
    }
    .right-side {
      display: none;
    }
  }
}
</style>
